import { withAccordionGroup } from '@talos/kyoko';
import type React from 'react';
import { memo, type PropsWithChildren } from 'react';
import { SelectionGrid } from './SelectionGrid/SelectionGrid';
import type { MarketAccountSelectionGridProps } from './types';
import { withMarketAccountSelection } from './withMarketAccountSelection';

export function withOptions<P extends object>(WrappedComponent: React.ComponentType<P>) {
  return function WrappedComponentWithOptions(props: PropsWithChildren<P & MarketAccountSelectionGridProps>) {
    return <WrappedComponent {...props} />;
  };
}

export const MarketAccountSelectionGrid = memo(
  withAccordionGroup(withOptions(withMarketAccountSelection(SelectionGrid)))
);
